import * as types from "../actions/actionTypes"
import initialState from "./initialState";

export default function settingReducer(state = initialState.settings, action) {
    switch (action.type) {
        case types.LOAD_SETTINGS_SUCCESS:
            return action.settings;
        case types.UPDATE_SETTINGS_GENERAL_SUCCESS:
            return action.settings;
        case types.UPDATE_SETTINGS_SITE_SUCCESS:
            return action.settings;
        case types.UPDATE_SETTINGS_PASSWORD_SUCCESS:
            return action.settings;
        case types.UPDATE_SETTINGS_AVATAR_SUCCESS:
            return action.settings;
        case types.UPDATE_SETTINGS_BANNER_SUCCESS:
            return action.settings;
        case types.LOGOUT_SUCCESS:
            return initialState.settings;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/settingsReducer.js